import type { ClipSort } from "../types";

interface SortDropdownProps {
  value: ClipSort;
  onChange: (value: ClipSort) => void;
}

export function SortDropdown({ value, onChange }: SortDropdownProps) {
  return (
    <label className="clip-sort">
      <span>Sort by</span>
      <select value={value} onChange={(event) => onChange(event.target.value as ClipSort)}>
        <option value="bangers-desc">Most Bangers</option>
        <option value="uploaded-desc">Newest uploaded</option>
        <option value="uploaded-asc">Oldest uploaded</option>
        <option value="recording-desc">Newest recording date</option>
        <option value="recording-asc">Oldest recording date</option>
      </select>
    </label>
  );
}
